import React from 'react';

interface SectionDividerProps {
  /** 仕切り中央に表示するラベル (見出しとして読み上げられる) */
  label: string;
}

/**
 * issue #153: セクションの区切りを示すラベル付き仕切り。
 * 左右の細い装飾線 (aria-hidden) で中央のラベルを挟む。ラベルは h2 見出しとして
 * 支援技術に読み上げられ、装飾線は読み上げ対象から除外する。
 */
const SectionDivider: React.FC<SectionDividerProps> = ({ label }) => (
  <div className="flex items-center gap-3">
    <span aria-hidden="true" className="flex-1 h-px bg-gray-200" />
    <h2 className="text-gray-400 text-xs font-medium">{label}</h2>
    <span aria-hidden="true" className="flex-1 h-px bg-gray-200" />
  </div>
);

export default SectionDivider;
